import { LocaleDatePipe } from './pipes/locale-date.pipe';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { StatusLabelComponent } from '@app/shared/components/status-label/status-label.component';
import { LoadingViewComponent } from '@app/shared/components/loading-view/loading-view.component';
import { CustomerRequestCustomerNameComponent } from './components/customer-request-customer-name/customer-request-customer-name.component';
import { CustomerRequestAdminNameComponent } from './components/customer-request-admin-name/customer-request-admin-name.component';
import { ConfirmComponent } from '@app/shared/components/confirm/confirm.component';
import { SafePipe } from '@app/shared/pipes/safe.pipe';
import { AutoresizeDirective } from '@app/shared/directives/autoresize.directive';
import { NoDataPipe } from '@app/shared/pipes/no-data-pipe';
import { SubscriptionServiceStatePipe } from './pipes/subscription-service-state.pipe';
import { MomentDateModule } from "@angular/material-moment-adapter";
import { EditBlocButtonsComponent } from '@app/shared/components/edit-bloc-buttons/edit-bloc-buttons.component';
import { SmartButtonComponent } from '@app/shared/components/smart-button/smart-button.component';
import { LicenseNumberUnicityValidator } from '@app/shared/directives/license-number-unicity.validator';
import { SubscriptionActionsComponent } from './components/subscription-actions/subscription-actions.component';
import { TranslateIfExistPipe } from './pipes/translate-if-exist.pipe';
import { PageTitleComponent } from './components/page/page-title/page-title.component';
import { PageComponent } from './components/page/page.component';
import { PageToolbarComponent } from './components/page/page-toolbar/page-toolbar.component';
import { PageContentComponent } from './components/page/page-content/page-content.component';
import { PanelComponent } from './components/panel/panel.component';
import { PanelTitleComponent } from './components/panel/panel-title/panel-title.component';
import { PanelContentComponent } from './components/panel/panel-content/panel-content.component';
import { BackToListButtonComponent } from './components/back-to-list-button/back-to-list-button.component';
import { DefaultIfEmptyPipe } from './pipes/defaultIfEmpty.pipe';
import { SideMenuItemComponent } from './components/side-menu/side-menu-item/side-menu-item.component';
import { SideSubmenuComponent } from './components/side-menu/side-submenu/side-submenu.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { SideSubMenuItemsComponent } from './components/side-menu/side-submenu/side-submenu-items.component';
import { RouterModule } from '@angular/router';
import { FilterListComponent } from './components/filter-list/filter-list.component';
import { PluralPipe } from './pipes/plural.pipe';
import { ApSecureDirective } from './directives/secure/secure.directive';
import { ImageViewerDialogComponent } from './components/image-viewer-dialog/image-viewer-dialog.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ProfileStatusPipe } from './pipes/profile-status.pipe';
import { LocalFilterPipe } from './pipes/local-filter.pipe';
import { ProfileTypeLabelPipe } from './pipes/profile-type-label.pipe';
import { YesNoPipe } from './pipes/yes-no.pipe';
import { RequestProfileDetailsContentComponent } from './components/request-profile-details-content/request-profile-details-content.component';
import { ProfileRequestDocumentaryProofsComponent } from './components/profile-request-documentary-proofs/profile-request-documentary-proofs.component';
import { DocumentaryProofCardComponent } from './components/documentary-proof-card/documentary-proof-card.component';
import { JumbotronComponent } from './components/jumbotron/jumbotron.component';
import { ManageProfileRequestDialogComponent } from './components/manage-profile-request-dialog/manage-profile-request-dialog.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { SubscriptionHolderPayerPipe } from './pipes/subscription-holder-payer.pipe';
import { ChecklistComponent } from './components/checklist/checklist.component';
import { ChecklistItemComponent } from './components/checklist/checklist-item/checklist-item.component';
import { ChecklistEmptyComponent } from './components/checklist/checklist-empty/checklist-empty.component';
import { CheckListItemDirective } from './components/checklist/checklist-item/checklist-item.directive';
import { ToolTipDirective } from './directives/tooltip.directive';
import { ButtonIconSelectComponent } from './components/button-icon-select/button-icon-select.component';
import { TransactionDetailsContentComponent } from './components/transaction-details-content/transaction-details-content.component';
import { ApCurrencyPipe } from './pipes/ap-currency.pipe';
import { OrderItemDetailsDialogComponent } from './components/order-item-details-dialog/order-item-details-dialog.component';
import { ApSecureAccountTypeDirective } from './directives/secure/secure-account-type.directive';
import { AddressPipe } from './pipes/address.pipe';
import { TransactionRefundContentComponent } from './components/transaction-refund-content/transaction-refund-content.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ImageViewerComponent } from './components/image-viewer/image-viewer.component';
import { CustomSnackBarComponent } from './components/custom-snack-bar/custom-snack-bar.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SubscriptionDetailsContentComponent } from './components/subscription-details-content/subscription-details-content.component';
import { SubscriptionPaymentMeanComponent } from './components/subscription-payment-mean/subscription-payment-mean.component';
import { InvoicesPanelComponent } from './components/subscription-details-content/invoices-panel/invoices-panel.component';
import { SubscriptionHolderPayerPanelComponent } from './components/subscription-details-content/subscription-holder-payer-panel/subscription-holder-payer-panel.component';
import { SubscriptionStatusHistoryPanelComponent } from './components/subscription-details-content/subscription-status-history-panel/subscription-status-history-panel.component';
import { AddSubscriptionHistoryPopupComponent } from './components/subscription-details-content/add-subscription-history-popup/add-subscription-history-popup.component';
import { SwitchToggleComponent } from './components/switch-toggle/switch-toggle.component';
import { TransactionDetailsOrdersComponent } from './components/transaction-details-content/transaction-details-orders/transaction-details-orders.component';
import { TransactionDetailsRefundsComponent } from './components/transaction-details-content/transaction-details-refunds/transaction-details-refunds.component';
import { TransactionDetailsAttemptsComponent } from './components/transaction-details-content/transaction-details-attempts/transaction-details-attempts.component';
import { InitialTransactionDetailsRefundedComponent } from './components/transaction-details-content/initial-transaction-details-refunded/initial-transaction-details-refunded.component';
import { InitialTransactionDetailsRecoveredComponent } from './components/transaction-details-content/initial-transaction-details-recovered/initial-transaction-details-recovered.component';
import { TransactionDetailsRecoversComponent } from './components/transaction-details-content/transaction-details-recovers/transaction-details-recovers.component';
import { RecoverExternallyModalComponent } from './components/transaction-details-content/recover-externally-modal/recover-externally-modal.component';
import { MaintenanceBannerComponent } from './components/maintenance-banner/maintenance-banner.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    RouterModule,
    NgxExtendedPdfViewerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatIconModule,
    MatPaginatorModule,
    MatSortModule,
    MaintenanceBannerComponent
  ],
  declarations: [
    SafePipe,
    LocaleDatePipe,
    AutoresizeDirective,
    StatusLabelComponent,
    LoadingViewComponent,
    CustomerRequestAdminNameComponent,
    CustomerRequestCustomerNameComponent,
    ConfirmComponent,
    NoDataPipe,
    SubscriptionServiceStatePipe,
    EditBlocButtonsComponent,
    SmartButtonComponent,
    LicenseNumberUnicityValidator,
    SubscriptionActionsComponent,
    TranslateIfExistPipe,
    PageComponent,
    PageTitleComponent,
    PageToolbarComponent,
    PageContentComponent,
    PanelComponent,
    PanelTitleComponent,
    PanelContentComponent,
    BackToListButtonComponent,
    DefaultIfEmptyPipe,
    SideMenuComponent,
    SideMenuItemComponent,
    SideSubmenuComponent,
    SideSubMenuItemsComponent,
    FilterListComponent,
    PluralPipe,
    ApSecureDirective,
    ImageViewerDialogComponent,
    ProfileStatusPipe,
    LocalFilterPipe,
    YesNoPipe,
    RequestProfileDetailsContentComponent,
    ProfileRequestDocumentaryProofsComponent,
    DocumentaryProofCardComponent,
    ButtonIconSelectComponent,
    JumbotronComponent,
    ManageProfileRequestDialogComponent,
    ProfileTypeLabelPipe,
    SubscriptionHolderPayerPipe,
    ChecklistComponent,
    ChecklistItemComponent,
    ChecklistEmptyComponent,
    CheckListItemDirective,
    ToolTipDirective,
    TransactionDetailsContentComponent,
    ApCurrencyPipe,
    OrderItemDetailsDialogComponent,
    ApSecureAccountTypeDirective,
    AddressPipe,
    TransactionRefundContentComponent,
    ImageViewerComponent,
    CustomSnackBarComponent,
    SubscriptionDetailsContentComponent,
    SubscriptionPaymentMeanComponent,
    InvoicesPanelComponent,
    SubscriptionHolderPayerPanelComponent,
    SubscriptionStatusHistoryPanelComponent,
    AddSubscriptionHistoryPopupComponent,
    SwitchToggleComponent,
    TransactionDetailsOrdersComponent,
    TransactionDetailsRefundsComponent,
    TransactionDetailsAttemptsComponent,
    InitialTransactionDetailsRefundedComponent,
    InitialTransactionDetailsRecoveredComponent,
    TransactionDetailsRecoversComponent,
    RecoverExternallyModalComponent
  ],
  exports: [
    TranslateModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    SafePipe,
    LocaleDatePipe,
    AutoresizeDirective,
    StatusLabelComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    LoadingViewComponent,
    CustomerRequestAdminNameComponent,
    CustomerRequestCustomerNameComponent,
    ConfirmComponent,
    NoDataPipe,
    SubscriptionServiceStatePipe,
    MomentDateModule,
    EditBlocButtonsComponent,
    SmartButtonComponent,
    LicenseNumberUnicityValidator,
    SubscriptionActionsComponent,
    TranslateIfExistPipe,
    PageComponent,
    PageTitleComponent,
    PageToolbarComponent,
    PageContentComponent,
    PanelComponent,
    PanelTitleComponent,
    PanelContentComponent,
    BackToListButtonComponent,
    DefaultIfEmptyPipe,
    SideMenuComponent,
    SideMenuItemComponent,
    SideSubmenuComponent,
    SideSubMenuItemsComponent,
    FilterListComponent,
    PluralPipe,
    ApSecureDirective,
    ImageViewerDialogComponent,
    ProfileStatusPipe,
    LocalFilterPipe,
    YesNoPipe,
    RequestProfileDetailsContentComponent,
    ProfileRequestDocumentaryProofsComponent,
    JumbotronComponent,
    ProfileTypeLabelPipe,
    SubscriptionHolderPayerPipe,
    ChecklistComponent,
    ChecklistItemComponent,
    ChecklistEmptyComponent,
    CheckListItemDirective,
    ToolTipDirective,
    DocumentaryProofCardComponent,
    TransactionDetailsContentComponent,
    ApCurrencyPipe,
    OrderItemDetailsDialogComponent,
    ApSecureAccountTypeDirective,
    AddressPipe,
    TransactionRefundContentComponent,
    MatCheckboxModule,
    ImageViewerComponent,
    CustomSnackBarComponent,
    SubscriptionDetailsContentComponent,
    SubscriptionPaymentMeanComponent,
    SwitchToggleComponent,
    MaintenanceBannerComponent
  ],
  providers: [
    LocaleDatePipe
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
